/* eslint-disable import/no-anonymous-default-export */
import { Card, Stack } from '@mui/material';
import {
    BulkActionsToolbar,
    BulkDeleteButton,
    CreateButton,
    ListBase,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
    useGetIdentity,
    useListContext
} from 'react-admin';

import { ContractorNetworkRankings } from './ContractorNetworkRankings';
import { ContractorOwnerEmpty } from './ContractorOwnerEmpty';
import { ContractorOwnerListContent } from './ContractorOwnerListContent';
import { ContractorOwnerListFilter } from './ContractorOwnerListFilter';

export const ContractorOwnerList = () => {
    const { identity } = useGetIdentity();

    if (!identity) return null;

    return (
        <ListBase
            disableAuthentication
            perPage={25}
            sort={{ field: 'id', order: 'DESC' }}
        >
            <ContractorOwnerListLayout />
        </ListBase>
    );
};

const ContractorOwnerListLayout = () => {
    const { data, isPending, filterValues } = useListContext();
    const { identity } = useGetIdentity();

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (!identity || isPending) return null;

    const isEmpty = !data?.length && !hasFilters;

    return (
        <Stack sx={{ width: '100%' }}>
            <ContractorNetworkRankings />
            {isEmpty ? (
                <ContractorOwnerEmpty />
            ) : (
                <Stack direction={{ xs: 'column', md: 'row' }} sx={{ width: '100%' }}>
                    <ContractorOwnerListFilter />
                    <Stack sx={{ width: '100%', minWidth: 0, flex: 1 }}>
                        <Title title={'Contractors'} />
                        <ListToolbar actions={<ContractorOwnerListActions />} />
                        <BulkActionsToolbar>
                            <BulkDeleteButton />
                        </BulkActionsToolbar>
                        <Card>
                            <ContractorOwnerListContent />
                        </Card>
                        <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};

const ContractorOwnerListActions = () => (
    <TopToolbar>
        <SortButton fields={['name', 'id', 'created_at']} />
        <CreateButton
            variant="contained"
            label="New Contractor"
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
